// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfigFragmentDoc } from '../components/BoundMaterialLeadTimeConfigFields.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type MaterialLeadTimesEditorTabMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MaterialLeadTimesEditorTabMetadataQuery = { __typename?: 'Query', markets: Array<{ __typename?: 'Market', id: string, name: string }> };

export type MaterialLeadTimesEditorTabQueryVariables = Types.Exact<{
  itemId: Types.Scalars['ID']['input'];
}>;


export type MaterialLeadTimesEditorTabQuery = { __typename?: 'Query', items: Array<{ __typename?: 'Item', id: string, materialLeadTimeConfig?: { __typename?: 'MaterialLeadTimeConfig', id: string, minLeadTimeInDays: number, maxLeadTimeInDays: number, expectedLeadTimeInDays: number, reasonNote?: string | null | undefined, variants: Array<{ __typename?: 'MaterialLeadTimeConfigVariant', id: string, minLeadTimeInDays?: number | null | undefined, maxLeadTimeInDays?: number | null | undefined, expectedLeadTimeInDays?: number | null | undefined, reasonNote?: string | null | undefined, market?: { __typename?: 'Market', id: string, name: string } | null | undefined }> } | null | undefined }> };

export type MaterialLeadTimesEditorTab_ItemFragment = { __typename?: 'Item', id: string, materialLeadTimeConfig?: { __typename?: 'MaterialLeadTimeConfig', id: string, minLeadTimeInDays: number, maxLeadTimeInDays: number, expectedLeadTimeInDays: number, reasonNote?: string | null | undefined, variants: Array<{ __typename?: 'MaterialLeadTimeConfigVariant', id: string, minLeadTimeInDays?: number | null | undefined, maxLeadTimeInDays?: number | null | undefined, expectedLeadTimeInDays?: number | null | undefined, reasonNote?: string | null | undefined, market?: { __typename?: 'Market', id: string, name: string } | null | undefined }> } | null | undefined };

export const MaterialLeadTimesEditorTab_ItemFragmentDoc = gql`
    fragment MaterialLeadTimesEditorTab_Item on Item {
  id
  materialLeadTimeConfig {
    ...BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfig
  }
}
    ${BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfigFragmentDoc}`;
export const MaterialLeadTimesEditorTabMetadataDocument = gql`
    query MaterialLeadTimesEditorTabMetadata {
  markets {
    id
    name
  }
}
    `;

/**
 * __useMaterialLeadTimesEditorTabMetadataQuery__
 *
 * To run a query within a React component, call `useMaterialLeadTimesEditorTabMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialLeadTimesEditorTabMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialLeadTimesEditorTabMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useMaterialLeadTimesEditorTabMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MaterialLeadTimesEditorTabMetadataQuery, MaterialLeadTimesEditorTabMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MaterialLeadTimesEditorTabMetadataQuery, MaterialLeadTimesEditorTabMetadataQueryVariables>(MaterialLeadTimesEditorTabMetadataDocument, options);
      }
export function useMaterialLeadTimesEditorTabMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MaterialLeadTimesEditorTabMetadataQuery, MaterialLeadTimesEditorTabMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MaterialLeadTimesEditorTabMetadataQuery, MaterialLeadTimesEditorTabMetadataQueryVariables>(MaterialLeadTimesEditorTabMetadataDocument, options);
        }
export function useMaterialLeadTimesEditorTabMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialLeadTimesEditorTabMetadataQuery, MaterialLeadTimesEditorTabMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MaterialLeadTimesEditorTabMetadataQuery, MaterialLeadTimesEditorTabMetadataQueryVariables>(MaterialLeadTimesEditorTabMetadataDocument, options);
        }
export type MaterialLeadTimesEditorTabMetadataQueryHookResult = ReturnType<typeof useMaterialLeadTimesEditorTabMetadataQuery>;
export type MaterialLeadTimesEditorTabMetadataLazyQueryHookResult = ReturnType<typeof useMaterialLeadTimesEditorTabMetadataLazyQuery>;
export type MaterialLeadTimesEditorTabMetadataSuspenseQueryHookResult = ReturnType<typeof useMaterialLeadTimesEditorTabMetadataSuspenseQuery>;
export type MaterialLeadTimesEditorTabMetadataQueryResult = Apollo.QueryResult<MaterialLeadTimesEditorTabMetadataQuery, MaterialLeadTimesEditorTabMetadataQueryVariables>;
export const MaterialLeadTimesEditorTabDocument = gql`
    query MaterialLeadTimesEditorTab($itemId: ID!) {
  items(filter: {id: [$itemId], version: [1, 2]}) {
    ...MaterialLeadTimesEditorTab_Item
  }
}
    ${MaterialLeadTimesEditorTab_ItemFragmentDoc}`;

/**
 * __useMaterialLeadTimesEditorTabQuery__
 *
 * To run a query within a React component, call `useMaterialLeadTimesEditorTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialLeadTimesEditorTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialLeadTimesEditorTabQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useMaterialLeadTimesEditorTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MaterialLeadTimesEditorTabQuery, MaterialLeadTimesEditorTabQueryVariables> & ({ variables: MaterialLeadTimesEditorTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MaterialLeadTimesEditorTabQuery, MaterialLeadTimesEditorTabQueryVariables>(MaterialLeadTimesEditorTabDocument, options);
      }
export function useMaterialLeadTimesEditorTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MaterialLeadTimesEditorTabQuery, MaterialLeadTimesEditorTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MaterialLeadTimesEditorTabQuery, MaterialLeadTimesEditorTabQueryVariables>(MaterialLeadTimesEditorTabDocument, options);
        }
export function useMaterialLeadTimesEditorTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialLeadTimesEditorTabQuery, MaterialLeadTimesEditorTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MaterialLeadTimesEditorTabQuery, MaterialLeadTimesEditorTabQueryVariables>(MaterialLeadTimesEditorTabDocument, options);
        }
export type MaterialLeadTimesEditorTabQueryHookResult = ReturnType<typeof useMaterialLeadTimesEditorTabQuery>;
export type MaterialLeadTimesEditorTabLazyQueryHookResult = ReturnType<typeof useMaterialLeadTimesEditorTabLazyQuery>;
export type MaterialLeadTimesEditorTabSuspenseQueryHookResult = ReturnType<typeof useMaterialLeadTimesEditorTabSuspenseQuery>;
export type MaterialLeadTimesEditorTabQueryResult = Apollo.QueryResult<MaterialLeadTimesEditorTabQuery, MaterialLeadTimesEditorTabQueryVariables>;